import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=3dde7ebb&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=3dde7ebb&prod&lang=scss"
import style1 from "./Notifications.vue?vue&type=style&index=1&id=3dde7ebb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dde7ebb",
  null
  
)

export default component.exports